<template>
    <div id="Schedule_Visit">
        <ScheduleVisitHomeHealth
            v-if="options.Application == applicationEnum.AgencyCore"
            :visit-details="options"
            :is-saving="isSaving"
            :is-loading="isLoading"
            v-on:loadingChange="handleLoadingChange"
            v-on:savingChange="handleSavingChange"
            :reassign="reassignVisit"
            :cancel="cancel"
            :ok="ok"
            :preSelectedEmployee="selectedEmployee"
        />

        <ScheduleVisitHomeCare
            v-if="options.Application == applicationEnum.HomeCare"
            :visit-details="options"
            :is-loading="isLoading"
            :is-saving="isSaving"
            v-on:loadingChange="handleLoadingChange"
            v-on:savingChange="handleSavingChange"
            :reassign="reassignVisit"
            :cancel="cancel"
            :ok="ok"
            :add-another="addAnother"
            :preSelectedEmployee="selectedEmployee"
        />

        <ScheduleVisitHosPal
            v-if="
                options.Application == applicationEnum.AxxessHospiceFE ||
                options.Application == applicationEnum.AxxessHospice ||
                options.Application == applicationEnum.AxxessPalliative
            "
            :visit-details="options"
            :is-loading="isLoading"
            v-model:isSaving="isSaving"
            :employee-list="employeeList"
            :reassign="reassignVisit"
            :cancel="cancel"
            :ok="ok"
            :preSelectedEmployee="selectedEmployee"
        />
    </div>
</template>

<script lang="ts" src="./ScheduleVisit.ts"></script>
<style src="./ScheduleVisit.scss"></style>
